import React from "react"
import { motion, AnimatePresence } from "framer-motion"
import ecommerceImg from '../../images/service-single/ecommerce.png'
import headlessImg from '../../images/service-single/headless.png'
import maintenanceImg from '../../images/service-single/maintenance.png'
import seoImg from '../../images/service-single/seo.png'
import landingImg from '../../images/service-single/landing.png'
import appImg from '../../images/service-single/app.png'

const serviceImages = [
  { src: ecommerceImg, alt: "Website E-Commerce" },
  { src: headlessImg, alt: "WordPress Headless CMS" },
  { src: maintenanceImg, alt: "Website Maintenance & Support" },
  { src: seoImg, alt: "SEO & GEO Optimization" },
  { src: landingImg, alt: "Landing Page" },
  { src: appImg, alt: "Android & iOS Application" }
];

const ImageSlider = ({ activeIndex }) => {
  const currentImage = serviceImages[activeIndex] || serviceImages[0];

  return (
    <div className="relative w-full h-auto overflow-hidden rounded-xl" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
      <AnimatePresence mode="wait">
        <motion.img
          key={activeIndex}
          src={currentImage.src}
          alt={currentImage.alt}
          className="w-full h-auto object-contain rounded-lg"
          style={{
            maxHeight: "487px",
            filter: "drop-shadow(0 15px 30px rgba(0, 0, 0, 0.4))"
          }}
          initial={{ opacity: 0, scale: 0.96 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 1.04 }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
        />
      </AnimatePresence>
    </div>
  );
};

export default ImageSlider;